import api from '@api';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getCarriersListFetchFailure, getCarriersListFetchSuccess } from './reducer';
import { CarriersListResType } from 'src/types/carriersList';

const getCarriersListFetchRequest = async () => {
    const res = await api('get', 'api/secure/carriers');
    return res.data.data;
};

function* getCarriersListFetch() {
    try {
        const response: CarriersListResType = yield call((): any => getCarriersListFetchRequest());
        yield put(getCarriersListFetchSuccess(response));
    } catch (error) {
        yield put(getCarriersListFetchFailure());
    }
}

export function* getCarriersListFetchWatch() {
    yield takeEvery('carriersList/getCarriersListFetch', getCarriersListFetch);
}

